<script setup lang="ts">
// import LoadingView from '../LoadingView.vue'
// import IngredientsList from '@/components/Menus/IngredientsList.vue'
// import { useFetch } from '@/composables/useFetch.js'
// import { useEnvStore } from '@/stores/envStore.js'
// import type { DishHistory, DishHistoryResponse } from '@/types/api.js'
// import Accordion from 'primevue/accordion'
// import AccordionTab from 'primevue/accordiontab'
// import Button from 'primevue/button'
// import Tag from 'primevue/tag'
// import { onMounted, ref, type Ref } from 'vue'

// const { fetchData, isFetching } = useFetch()
// const apiUrl = useEnvStore().apiUrl

// const nextPageUrl = ref(`${apiUrl}/admin/dishes`)
// const loadedDishes = ref(0)
// const totalDishes = ref(0)

// const dishes: Ref<DishHistory[]> = ref([])
// console.log('apiUrl', apiUrl)
// console.log(useEnvStore().environment)

// async function getDishes() {
//   const { data, error } = await fetchData(nextPageUrl.value, 'GET')
//   if (error) {
//     console.log('error', error)
//   } else {
//     const response = data as DishHistoryResponse
//     console.log('response', response)
//     dishes.value = [...dishes.value, ...response.data]
//     loadedDishes.value = response.to
//     totalDishes.value = response.total
//     response.next_page_url ? (nextPageUrl.value = response.next_page_url) : (nextPageUrl.value = '')
//   }
// }
// onMounted(() => {
//   getDishes()
// })
</script>

<template>
  <main>
    <!-- <div v-if="dishes">
      <div
        v-for="dish in dishes"
        :key="dish.id"
        class="p-3 mb-4 border border-primary-500 rounded-xl"
        @click="$router.push(`/menu/dishes/${dish.id}`)"
      >
        <div class="flex flex-row justify-between mb-2">
          <h3 class="text-xl">{{ dish.name }}</h3>
          <Tag
            :value="dish.created_using.toUpperCase()"
            :severity="dish.created_using === 'ia' ? 'primary' : 'secondary'"
          />
        </div>

        <ul class="flex flex-col">
          <li>
            <h4 class="inline">Dish ID</h4>
            {{ dish.id }}
          </li>
          <li>
            <h4 class="inline">Date de creation</h4>
            {{ new Date(dish.created_at).toLocaleString('fr-CH') }}
          </li>
          <li>
            <h4 class="inline">Difficulty</h4>
            {{ dish.difficulty }}
          </li>
          <li>
            <h4 class="inline">Profil</h4>
            {{ dish.restaurant?.name ?? 'Inconnu' }}
          </li>
          <li>
            <h4 class="inline">Ingredients</h4>
            <IngredientsList
              gradientFrom="white"
              list-height="full"
              :servings="10"
              :ingredients="
                dish.ingredients.map((i) => {
                  return {
                    category: i.category,
                    name: i.name,
                    quantity: i.quantity,
                    price: i.price,
                    unit: i.unit,
                  }
                })
              "
            />
          </li>
        </ul>
        <Accordion @click.stop>
          <AccordionTab header="AI Infos">
            <ul class="flex flex-col">
              <li><b>Model</b> {{ dish.ai_request.model }}</li>
              <li><b>Prompt token</b> {{ dish.ai_request.prompt_token }}</li>
              <li><b>Completion token</b> {{ dish.ai_request.completion_token }}</li>
              <li><b>Completion duration</b> {{ dish.ai_request.completion_time_sec }} sec</li>
              <li><b>Thread ID</b> {{ dish.ai_request.thread_id }}</li>
            </ul>
          </AccordionTab>
          <AccordionTab header="Request">
            <pre>{{ JSON.parse(dish.ai_request.request_json) }}</pre>
          </AccordionTab>
        </Accordion>
      </div>
      <Button
        v-if="loadedDishes < totalDishes"
        @click="getDishes()"
        :loading="isFetching && dishes.length !== 0"
        label="Voir plus"
      />
    </div>
    <LoadingView v-if="isFetching && dishes.length === 0" /> -->
  </main>
</template>
